import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=20e69ef8&lang=css"
import "./index.vue?vue&type=style&index=1&id=20e69ef8&scoped=true&lang=less"
import "./index.vue?vue&type=style&index=2&id=20e69ef8&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e69ef8"]])

export default __exports__